import GatewayContainer from '../config/GatewayContainer';
import GatewayNames from '../constant/GatewayNames';
import { RoleClient } from '../client/role/RoleClient';
import { Role } from '../domain/rbac/RbacDomains';
import MessageUtil from '../util/MessageUtil';
import LanguageUtil from '../util/LanguageUtil';
import React from 'react';
import { isStringValid } from '../util/Generator';
import { query } from '@trlogic/client-js';
import Query = query.Query;
import { dispatch } from '../redux/store';
import { openBulkActionDialogFromDependency } from '../redux/actions/BulkActionActions';
import EnvironmentUtil from '../util/EnvironmentUtil';
import { InstanceContainer } from '../config/binding/InstanceBinding';
import Injectables from '../constant/Injectables';

class RoleService {
  private roleClient: RoleClient = GatewayContainer.getInstance().get(GatewayNames.ROLE_CLIENT);
  private readonly environmentUtil: EnvironmentUtil = InstanceContainer.get(Injectables.ENVIRONMENT_UTIL);

  public async saveRole(id: string, role: Role, isCreate: boolean) {
    if (role.name != undefined) {
      try {
        if (isCreate) {
          let exist = await this.roleClient.exist(role.name);
          if (exist) {
            return MessageUtil.error({
              summary: LanguageUtil.get({ id: 'common.label.role', defaultMessage: 'Role' }),
              detail: (
                <div>
                  {role.name} {LanguageUtil.get({ id: 'messages.warning.roleAlready', defaultMessage: 'Role has already exist' })}
                </div>
              ),
            });
          }
        }
      } catch (e) {
        console.log(e);
        return MessageUtil.error({
          content: LanguageUtil.get({ id: 'messages.error.errorCheckName', defaultMessage: 'Ann error when check this name is exist' }),
        });
      }
    }

    if (this.environmentUtil.isLdapOnly() ? role.name.length == 0 : !(isStringValid(role.name) && role.name.length > 0)) {
      return MessageUtil.error({
        summary: LanguageUtil.inappropriateCharacters(),
      });
    }

    try {
      await this.roleClient.save(role.name, role);
      MessageUtil.success({
        detail: <div>{LanguageUtil.get({ id: 'messages.success.roleSaved', defaultMessage: 'role saved' })}</div>,
      });
      return true;
    } catch (e) {
      MessageUtil.error({
        detail: <div>{LanguageUtil.get({ id: 'messages.error.error', defaultMessage: 'There is an error ' })}</div>,
      });
    }
  }

  public async deleteRole(id: string) {
    try {
      await this.roleClient.delete(id);
      MessageUtil.success({
        summary: 'Role',
        detail: (
          <div>
            <b>{id}</b> {LanguageUtil.get({ id: 'messages.removed', defaultMessage: 'deleted' })}
          </div>
        ),
      });
    } catch (e: any) {
      const dependencies: any = e.response.data;
      if (dependencies) {
        dispatch(openBulkActionDialogFromDependency(dependencies, 'Role' as any));
        return dependencies;
      }
      if (e) {
        if (e.response) {
          return MessageUtil.error({
            summary: LanguageUtil.get({ id: 'common.label.role', defaultMessage: 'Role' }),
            detail: (
              <div>
                <b>{JSON.stringify(e.response.data)}</b> {LanguageUtil.get({ id: 'messages.cannotRemoved', defaultMessage: 'cannot delete' })}
              </div>
            ),
          });
        }
        return MessageUtil.error({
          summary: LanguageUtil.get({ id: 'common.label.role', defaultMessage: 'Role' }),
          detail: (
            <div>
              <b>{JSON.stringify(e.reason)}</b> {LanguageUtil.get({ id: 'messages.cannotRemoved', defaultMessage: 'cannot delete' })}
            </div>
          ),
        });
      } else {
        return MessageUtil.error({
          summary: LanguageUtil.get({ id: 'common.label.role', defaultMessage: 'Role' }),
          detail: (
            <div>
              <b>{id}</b> {LanguageUtil.get({ id: 'messagescannotRemoved', defaultMessage: 'cannot delete' })}
            </div>
          ),
        });
      }
    }
  }

  public getCount(query: Query) {
    return this.roleClient.getCount(query);
  }
}

export default RoleService;
